module.exports = __webpack_public_path__ + "img/jutai.715cc0ff.jpg";